<template>
    <div id="specifications" class="tab-pane fade pb-3" v-if="product != null && product.specifications != '' " :class="activeTab === 'specifications' ? 'in active show' :''">
        <div class="">
          <table class="table table-bordered fontsize-small">
            <tbody>
              <tr v-for="(specification,indeX) in product.specifications" :key="indeX">
                <th scope="row" class="bg-color-fa text-center w-25 "> {{specification.label != null ? specification.label : specification.name }} :</th>
                <td class="text-right pr-4">
                  <template v-if="specification.pivot && specification.pivot.specification_values != ''">
                    <span v-for="(values, index) in specification.pivot.specification_values" :key="365+index"> {{values.value }} {{index != specification.pivot.specification_values.length - 1 ? '-' : ''}} </span>
                  </template>
                  <template v-else-if="specification.pivot && specification.pivot.specification_value">
                    {{ specification.pivot.specification_value.value }}
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
</template>
<script>
  export default {
      props:['activeTab' , 'product'],
  }
</script>
